import api from "./api";

const normalizeLoginResponse = (response) => {
  const payload = response?.data ?? response?.Data ?? response;
  const success =
    payload?.success === true ||
    payload?.Success === true ||
    payload?.isSuccess === true ||
    payload?.IsSuccess === true;

  return {
    payload,
    success,
    message: payload?.message || payload?.Message || payload?.error || payload?.Error || "",
  };
};

export const login = async (email, password) => {
  try {
    const response = await api.post("/Auth/Login", {
      email,
      password,
    });

    const normalized = normalizeLoginResponse(response);

    return normalized.success
      ? normalized.payload
      : {
          success: false,
          message: normalized.message || "Login failed.",
        };
  } catch (error) {
    const serverMessage =
      error?.response?.data?.message ||
      error?.response?.data?.Message ||
      error?.message ||
      "Unable to connect to the server.";

    return {
      success: false,
      message: serverMessage,
    };
  }
};